import React, { useState, useEffect } from 'react';
import { navLinks, siteData } from '../data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('home');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    setActive(href.replace('#', ''));
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`fixed top-0 w-full z-[100] transition-all duration-500 px-6 md:px-12 py-4 ${scrolled ? 'nav-scrolled' : ''}`}>
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <a href="#home" onClick={() => handleNavClick('#home')} className="flex items-center gap-3 group">
            <div className="w-10 h-10 rounded-sm flex items-center justify-center relative overflow-hidden">
               <img src="/images/logos/mainlogo.png" className="w-full h-full object-contain" alt="ITS Academy Logo" />
            </div>
            
            <div>
              <div className="font-playfair font-black text-xl text-white leading-none">
                ITS <span className="text-gold-DEFAULT" style={{color:'#C8A84B'}}>Academy</span>
              </div>
              <div className="text-[10px] tracking-widest text-gray-500 uppercase">Saharanpur</div>
            </div>
          </a>

          {/* Desktop Links */}
          <ul className="hidden xl:flex items-center gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <button
                  onClick={() => handleNavClick(link.href)}
                  className={`px-3 py-2 text-[0.78rem] tracking-wide font-medium transition-all duration-300 relative group
                    ${active === link.href.replace('#','') ? 'text-yellow-500' : 'text-gray-400 hover:text-white'}`}
                  style={{fontFamily:'DM Sans,sans-serif'}}
                >
                  {link.label}
                  <span className={`absolute bottom-0 left-0 h-[1px] bg-yellow-500 transition-all duration-300
                    ${active === link.href.replace('#','') ? 'w-full' : 'w-0 group-hover:w-full'}`} />
                </button>
              </li>
            ))}
            <li>
              <button
                onClick={() => handleNavClick('#contact')}
                className="btn-gold ml-2 text-[0.78rem] tracking-wider uppercase font-bold px-5 py-2"
                style={{fontFamily:'DM Sans,sans-serif'}}
              >
                Enroll Now
              </button>
            </li>
          </ul>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="xl:hidden flex flex-col gap-[5px] p-2 z-50"
            aria-label="Menu"
          >
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`} />
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-[2px] bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 z-[99] flex flex-col items-center justify-center gap-6 transition-all duration-500
        ${menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        style={{background:'rgba(10,10,20,0.98)',backdropFilter:'blur(20px)'}}>
        {navLinks.map((link, i) => (
          <button
            key={link.href}
            onClick={() => handleNavClick(link.href)}
            className="font-playfair text-3xl text-white hover:text-yellow-400 transition-all duration-300"
            style={{ animationDelay: `${i * 0.05}s`, fontFamily: 'Playfair Display,serif' }}
          >
            {link.label}
          </button>
        ))}
        <button
          onClick={() => handleNavClick('#contact')}
          className="btn-gold mt-4 text-sm tracking-widest uppercase font-bold"
        >
          Enroll Now →
        </button>
      </div>
    </>
  );
}
